import { memo, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

import styled from 'styled-components';

const PartnerView = memo(() => {
  const [searchParams] = useSearchParams();
  const partnerUrl = searchParams.get('url');
  const redirect = searchParams.get('redirect');

  const iframeRef = useRef<HTMLIFrameElement>(null);

  localStorage.setItem(
    'activeView',
    JSON.stringify({ view: 'partner', url: partnerUrl })
  );

  const handleIframeLoad = async () => {
    const tokens: Record<string, string> = Object.keys(localStorage).reduce(
      (items, key) => {
        const value = localStorage.getItem(key);
        if (value) {
          items[key] = value;
        }
        return items;
      },
      {} as Record<string, string>
    );

    Object.keys(tokens).forEach(key => {
      if (!key.startsWith('CognitoIdentityServiceProvider')) {
        delete tokens[key];
      }
    });

    if (iframeRef.current) {
      for (let i = 0; i < 5; i++) {
        setTimeout(() => {
          iframeRef.current?.contentWindow?.postMessage(
            { tokens },
            new URL(partnerUrl ?? '').origin
          );
        }, i * 500);
      }
    }
  };

  return (
    <SystemWrapper>
      <Iframe
        ref={iframeRef}
        src={`${partnerUrl}/portal-signin?redirect=${redirect ?? ''}`}
        title='Claim system'
        allow='clipboard-read; clipboard-write'
        onLoad={handleIframeLoad}
      />
    </SystemWrapper>
  );
});

export default PartnerView;

const SystemWrapper = styled.section`
  flex: 1;
  height: 100vh;
  margin-left: 4rem;
`;

const Iframe = styled.iframe`
  border: none;
  height: 100%;
  width: 100%;
`;
